import { Component, input } from '@angular/core';
import { Calendar, Images, ImageUp, LucideAngularModule, Tag, User, Video } from 'lucide-angular';

@Component({
  selector: 'app-link-box',
  imports: [LucideAngularModule],
  templateUrl: './link-box.component.html',
})
export class LinkBoxComponent {
  title = input.required<string>();
  url = input.required<string>();
  icon = input<string>();
  active = input<boolean>(true);
  fullWidth = input<boolean>(false);
  small = input<boolean>(false);

  readonly video = Video;
  readonly calendar = Calendar;
  readonly tag = Tag;
  readonly user = User;
  readonly imageUp = ImageUp;
  readonly images = Images;

  openUrl() {
    window.open(this.url(), '_blank');
  }

  getIcon() {
    switch (this.icon()) {
      case 'video':
        return this.video;
      case 'calendar':
        return this.calendar;
      case 'tag':
        return this.tag;
      case 'user':
        return this.user;
      case 'image-up':
        return this.imageUp;
      case 'images':
        return this.images;
      default:
        return undefined;
    }
  }
}
